import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

export const Slider0 = ({ data }) => {
  const component = data;
  const sliders = data.get_home_component_details.content;

  const [sliderHeight, setSliderHeight] = useState("200px");
  const [sliderMobileHeight, setMobileSliderHeight] = useState("200px");
  const [title, setTitle] = useState("");
  const [font, setFont] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("left");

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setSliderHeight(component.web_height || "200px");
    setTitle(component.title);
    setFont(component.web_title_font);
    setTitleAlignment(component.title_alignment);
       setMobileSliderHeight(component.height || "200px");

    // Detect mobile screen
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, [component]);

  return (
    <div className="w-full">
      {/* Title */}
      <div
        className="mb-2 text-2xl font-bold"
        style={{ fontFamily: font, textAlign: titleAlignment }}
      >
        {title}
      </div>

      {/* -------- MOBILE SLIDER ---------- */}
      {isMobile && (
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2200, disableOnInteraction: false }}
          loop={true}
          spaceBetween={10}
          slidesPerView={1}
          className="w-full"
        >
          {sliders.map((slider) => (
            <SwiperSlide key={slider.component_auto_id}>
              <img
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${slider.component_image}`}
                alt={slider.title}
                className="object-cover w-full p-1"
                style={{ height: "350px" }}   
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* -------- DESKTOP SLIDER ---------- */}
      {!isMobile && (
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2200, disableOnInteraction: false }}
          loop={true}
          spaceBetween={10}
          slidesPerView={1}
          className="w-full"
        >
          {sliders.map((slider) => (
            <SwiperSlide key={slider.component_auto_id}>
             <img
  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${slider.component_image}`}
  alt={slider.title}
  className="object-cover w-full p-1"
  style={{
    height: sliderMobileHeight,
    maxHeight: "550px",   // 🔥 Prevents overflow in desktop
    width: "100%",
  }}
/>

            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};
